// extracted by mini-css-extract-plugin
export default {"pubblicita":"pubblicita_pubblicita__-2pES"};